import {Component} from '@angular/core';

import {ViewManagerService} from "src/app/services/view-manager.service";
import {SessionManagerService} from "../../../services/session-manager.service";

@Component({
  selector: '[admin-nav-menu]',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {

  constructor(
    private viewManager: ViewManagerService,
    private sessionManager: SessionManagerService
  ) {

  }

  getSession() {
    return this.sessionManager.session
  }

  isLoggedIn() {
    return this.sessionManager.isLoggedIn
  }

  getLanguages() {
    return this.viewManager.getLanguages()
  }

  getLanguage() {
    return this.viewManager.language
  }

  selectLanguage(selected: string) {
    this.viewManager.setLanguage(selected)
  }

}
